module.exports = __webpack_public_path__ + "img/矩形(5).e82eb3b1.png";